import { Component, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-select-multilevel',
  imports: [NgSelectComponent, FormsModule,CommonModule],
  templateUrl: './select-multilevel.component.html',
  styleUrl: './select-multilevel.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectMultilevelComponent),
      multi: true,
    },
  ],
  standalone: true
})
export class SelectMultilevelComponent implements ControlValueAccessor{
  @ViewChild('vs', { static: true }) sel: NgSelectComponent;
  @Output() selectionChanged = new EventEmitter<string>();
  @Input() initialSelectedValue: string | null = null;
  @Input() allowParentSelection = false;
  @Input() appendToBody = true;
  @Input() multiple = false;
  @Input() closeOnSelect = true;

  public selected;
  isLoading = true;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _data: any[] = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() public set pageResult(v: any) {
    this._data = v;
    this.isLoading = false;
  }
  _cssClass = '';

  @Input() public set cssClass(v: string) {
    this._cssClass = v;
  }

  _bindLabel: string;

  @Input() public set bindLabel(v: string) {
    this._bindLabel = v;
  }
  _placeHolder;
  @Input() public set placeHolder(v: string) {
    this._placeHolder = v;
  }
  _clearable = true;
  @Input() public set clearable(v: boolean) {
    this._clearable = v;
  }

  _groupBy;
  @Input() public set groupBy(v: string) {
    this._groupBy = v;
  }

  @Input() public disabled = false;


  private _value: string[];
  @Input() public get value(): string[] {
    return this._value;
  }
  public set value(v: string[]) {
    this._value = v;
    this.selectDropdown(v);
  }

  @Input()
  set clearSelectedValue(value: boolean) {
    if (value) {
      this.clearSelection();
    }
  }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
  searchAccounts(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.name.toLocaleLowerCase().indexOf(term) > -1;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-empty-function
  onChanged: any = () => {};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-empty-function
  onTouched: any = () => {};

  //gets the value from the formControl
  writeValue(val) {
    this.selectDropdown(val);
  }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnChange(fn: any) {
    this.onChanged = fn;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  selectDropdown(val) {
    this.selected = val;
  }

  onSelect(ev) {
    this.onTouched();
    this.onChanged(this.multiple ? this.selected.map(item => item) : ev?.id);
    this.selectionChanged.emit(this.multiple ? this.selected.map(item => item) : ev?.id);
  }

  onBlur() {
    this.onTouched();
    if (!this.selected) {
      this.onChanged(null);

    }
  }

  clearSelection() {
    this.selected = null;
    this.onChanged(null);
    this.selectionChanged.emit(null); // Emit null for cleared value
  }



}
